export enum Gender {
  MASCULINE = 'MASCULINO',
  FEMININE = 'FEMININO',
  OTHERS = 'OUTRO'
}
